// @flow

import { Map } from 'immutable';
import { createSelector } from 'reselect';

const LOCALE_PARAM = 'locale';
const DEFAULT_SIGNIN_OPTION = 'act_fb';

const getPassportSettings = (state: Map<*, *>) => state.getIn([ 'app', 'appSettings', 'passportSettings' ]);

export const getLocale = (state: Map<*, *>) => state.getIn([ 'app', 'locale' ]);

export const isFetchUserDone = (state: Map<*, *>) => state.getIn([ 'app', 'fetchUserDone' ]);

export const getAvailableLanguages = (state: Map<*, *>) => state.getIn([ 'app', 'availableLanguages' ]);

const getSigninOptionFromUrl = () => {
  if (typeof window === 'undefined' || !window.location) {
    return DEFAULT_SIGNIN_OPTION;
  }

  try {
    const params = new URLSearchParams(window.location.search || '');
    return params.get('signinOption') || DEFAULT_SIGNIN_OPTION;
  } catch (e) {
    return DEFAULT_SIGNIN_OPTION;
  }
};

export const getPassportLink = createSelector(
  [ getLocale, getPassportSettings ],
  (locale) => {
    // Spring Security OIDC login entry point (server-side redirect to Active Passport).
    const signinOption = getSigninOptionFromUrl();
    const params = [ `signinOption=${encodeURIComponent(signinOption)}` ];

    if (locale) {
      params.push(`${LOCALE_PARAM}=${encodeURIComponent(locale)}`);
    }

    params.push('redirect_uri=');
    return `/oauth2/authorization/active-passport?${params.join('&')}`;
  },
);

export const getPassportSignOutLink = createSelector(
  [ getLocale, getPassportSettings ],
  () => {
    // Spring Security logout endpoint (configured to redirect to Active Passport signout).
    return '/logout?redirect_uri=';
  },
);

export const getFacebookAppId = (state: Map<*, *>) => state.getIn([ 'app', 'appSettings', 'facebookAppId' ]);

export const getStaticContentServiceUrl = (state: Map<*, *>) => state.getIn([ 'app', 'appSettings', 'staticContentServiceUrl' ]);

export const getFeatureToggles = (state: Map<*, *>) => state.getIn([ 'app', 'appSettings', 'featureToggle' ]);

export const isAppReady = (state: Map<*, *>) => {
  return !!state.getIn([ 'app', 'fetchUserDone' ]);
};

export const getEnduranceSignUpLink = (state: Map<*, *>) => state.getIn([ 'app', 'appSettings', 'enduranceSettings', 'enduranceSignUpUrl' ]);

export const getPortalPath = (state: Map<*, *>) => state.getIn([ 'app', 'portalPath' ]);

export const hasUsedPortalPath = createSelector(getPortalPath, portalPath => !!(portalPath && portalPath.get('portalType') && portalPath.get('portalId')));
